import {
  DefaultGlobalNotFound,
  Outlet,
  createRootRoute,
} from "@tanstack/react-router"
import { localeHeadLinks } from "@holigral/shared/seo"
import { meta } from "@/content"
import { withProfiler } from "@/monitoring"
import { Root } from "@/base"
import appCss from "@/index.css?url"
// Initialises i18next with the app's catalogues (initReactI18next needs no provider)
import "@/i18n"

export const Route = createRootRoute({
  head: ({ matches }) => {
    const pathname = matches[matches.length - 1]?.pathname ?? "/"
    const links = [
      { rel: "stylesheet", href: appCss },
      // The emblem alone, which is the one place it appears without
      // the logotype. It carries the sun, as it always does.
      { rel: "icon", type: "image/svg+xml", href: "/favicon.svg" },
      ...localeHeadLinks("https://profiling.app", pathname),
    ]

    return {
      meta: [
        { charSet: "utf-8" },
        { name: "viewport", content: "initial-scale=1, width=device-width" },
        { name: "theme-color", content: "#475569" },
        ...meta({
          title: "Profiling.app",
        }),
      ],
      links,
      scripts: [
        { src: "/env.js" },
        {
          // Load Huginn (Umami) and route every event through maskTenant, which
          // strips the /t/<tenantSlug> segment from url + referrer to /t/[id]
          // before send so tenant slugs never reach analytics (issue #92).
          children:
            '(function(){window.maskTenant=function(t,p){if(p){var r=new RegExp("/t/[^/?#]+","g");if(p.url)p.url=p.url.replace(r,"/t/[id]");if(p.referrer)p.referrer=p.referrer.replace(r,"/t/[id]")}return p};var e=window.env;if(e&&e.HUGINN_ID){var s=document.createElement("script");s.defer=true;s.src="https://huginn.motley.dev/huginn.js";s.dataset.websiteId=e.HUGINN_ID;s.dataset.beforeSend="maskTenant";document.head.appendChild(s)}})()',
        },
      ],
    }
  },
  component: withProfiler(() => (
    <Root>
      <Outlet />
    </Root>
  )),
  notFoundComponent: DefaultGlobalNotFound,
})
